import React from 'react';
import { Loader2 } from 'lucide-react';

export default function SubmitButton({
    isSubmitting,
    onClick,
    disabled = false,
    className = "",
    children,
    loadingText = "Traitement...",
    type = "button",
    ...props
}) {
    return (
        <button
            type={type}
            onClick={onClick}
            disabled={isSubmitting || disabled}
            className={`
                inline-flex items-center justify-center gap-2 px-5 py-2.5 text-sm font-medium rounded-lg shadow-sm transition-all duration-300
                ${isSubmitting ? "opacity-75 blur-[1px] cursor-not-allowed bg-indigo-500 text-white" : ""}
                ${disabled && !isSubmitting ? "opacity-50 cursor-not-allowed bg-gray-400 text-white" : ""}
                ${!isSubmitting && !disabled ? "bg-indigo-600 hover:bg-indigo-700 text-white" : ""}
                ${className}
            `}
            {...props}
        >
            {isSubmitting ? (
                <>
                    <Loader2 className="w-4 h-4 animate-spin" />
                    <span>{loadingText}</span>
                </>
            ) : (
                children
            )}
        </button>
    );
}
